import React, { FC } from 'react'
import { Container, NavDropdown, Navbar } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { texts } from '../utils/texts'
import { PATHS, SUPPORT_EMAIL } from '../utils/shared/constants'
import config from '../utils/config'
import { useSigninCheck } from 'reactfire'
interface IProps {
    public?: boolean
    handleLogout?: () => void
}

interface CustomNavItemProps extends React.ComponentProps<typeof NavDropdown.Item> {
    link?: string;
    icon: string;
}

const IconNavItem: React.FC<CustomNavItemProps> = (props) => {
    const { icon, children, link, ...rest } = props;
    return <NavDropdown.Item {...rest as any} as={link ? Link : undefined} to={link}>
        <i className={`bi ${icon} me-2`} />{children}
    </NavDropdown.Item>;
};


export const Header: FC<IProps> = (props) => {
    const { data } = useSigninCheck({ requiredClaims: { superAdmin: true } })
    const isAdmin = data?.hasRequiredClaims;

    const renderItems = () => {
        if (props.public) {
            return <></>
        }

        return <>
            <NavDropdown title={'Menu'} menuVariant='right' >
                <IconNavItem icon="bi-microsoft" href={config.functions.initAzureAuth}>Connect BC</IconNavItem>
                <IconNavItem href={`mailto:${SUPPORT_EMAIL}`} icon="bi-question-circle">Support</IconNavItem>
                {isAdmin && <IconNavItem icon="bi-gear" link={PATHS.ADMIN}>Admin</IconNavItem>}
                <NavDropdown.Divider />
                <IconNavItem icon="bi-box-arrow-right" onClick={props.handleLogout}>{texts.logout}</IconNavItem >
            </NavDropdown>
        </>
    }

    return (
        <Navbar expand="lg" className="text-primary">
            <Container>
                <Link to={'/'}><Navbar.Brand className="text-primary">{texts.brand}</Navbar.Brand></Link>
                {renderItems()}
            </Container>
        </Navbar>
    )
}
